const data: any = {
  cta: {
    title: 'View all categories',
    url: '/category/all'
  },
  data: [
    {
      title: 'WordPress Themes',
      subtitle: 'Thousands of WordPress themes',
      category: 'wordpress'
    },
    {
      title: 'eCommerce Templates',
      subtitle: 'Beautiful website templates',
      category: 'ecommerce'
    },
    {
      title: 'Site Templates',
      subtitle: 'HTML and website templates',
      category: 'site-templates'
    },
    {
      title: 'Marketing Templates',
      subtitle: 'Email, newsletter and landing page templates.',
      category: 'marketing'
    },
    {
      title: 'CMS Templates',
      subtitle: 'Over 1,700 CMS website templates',
      category: 'cms-themes'
    },
    {
      title: 'Blogging',
      subtitle: 'Blogger templates and themes',
      category: 'blogging'
    }
  ]
}

export default data
